// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 900) return "static/chunks/900.468b3cbefcb222ce.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 634 ? "2c796e83" : chunkId) + "-" + {"312":"5298b67c29144277","634":"e761154a10c1213d"}[chunkId] + ".js";
};